import * as zod from "zod";

export const filterSideBarSchema = zod.object({
  marketSegment: zod.array(zod.string()).optional(),
  projectType: zod.array(zod.string()).optional(),
  status: zod.array(zod.string()).optional(),
  unitSizeMin: zod.string().nullable().optional(),
  unitSizeMax: zod.string().nullable().optional(),
  unitPSFMin: zod.string().nullable().optional(),
  unitPSFMax: zod.string().nullable().optional(),
});

export type TFilterSideBarFormData = zod.infer<typeof filterSideBarSchema>;
